/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      flex: 1,
    },
    instructionsWrapper: {
      margin: 8,
    },
    textWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    spacerLine: {
      marginVertical: 16,
      borderBottomWidth: 1,
      borderColor: colors.primaryExtraLight,
    },
    textAndIconWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 8,
    },
    multilineText: {
      display: 'flex',
      flexDirection: 'column',
    },
    instructionsText: {
      display: 'flex',
      flexShrink: 1,
      fontSize: globalScale * 18,
      color: colors.white,
    },
    boldText: {
      color: colors.white,
      fontFamily: fonts.primaryBold,
    },
    iconsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      fontSize: globalScale * 24,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: globalScale * 4,
      borderWidth: globalScale * 1,
      borderRadius: globalScale * 17,
      padding: globalScale * 4,
      borderColor: colors.white,
    },
  };
};

export default getStyles;
